import { defineComponent as a, createBlock as t, openBlock as p, resolveDynamicComponent as r, normalizeStyle as i, normalizeClass as s, unref as e, withCtx as m, renderSlot as g } from "vue";
import o from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/layouts/Flex/flex.js";
import { l_flex_item_Order as d } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/l_flex_item_Order.js";
import { cssVarsFromBreakpointProps as f, classesFromBreakpointProps as n } from "../../breakpoints.js";
const X = /* @__PURE__ */ a({
  name: "PfFlex",
  __name: "Flex",
  props: {
    component: { default: "div" },
    align: {},
    alignSm: {},
    alignMd: {},
    alignLg: {},
    alignXl: {},
    alignXl2: {},
    alignContent: {},
    alignContentSm: {},
    alignContentMd: {},
    alignContentLg: {},
    alignContentXl: {},
    alignContent2xl: {},
    alignItems: {},
    alignItemsSm: {},
    alignItemsMd: {},
    alignItemsLg: {},
    alignItemsXl: {},
    alignItems2xl: {},
    alignSelf: {},
    alignSelfSm: {},
    alignSelfMd: {},
    alignSelfLg: {},
    alignSelfXl: {},
    alignSelf2xl: {},
    columnGap: {},
    columnGapSm: {},
    columnGapMd: {},
    columnGapLg: {},
    columnGapXl: {},
    columnGap2xl: {},
    direction: {},
    directionSm: {},
    directionMd: {},
    directionLg: {},
    directionXl: {},
    direction2xl: {},
    display: {},
    displaySm: {},
    displayMd: {},
    displayLg: {},
    displayXl: {},
    display2xl: {},
    flex: {},
    flexSm: {},
    flexMd: {},
    flexLg: {},
    flexXl: {},
    flex2xl: {},
    flexWrap: {},
    flexWrapSm: {},
    flexWrapMd: {},
    flexWrapLg: {},
    flexWrapXl: {},
    flexWrap2xl: {},
    fullWidth: { type: Boolean },
    fullWidthSm: { type: Boolean },
    fullWidthMd: { type: Boolean },
    fullWidthLg: { type: Boolean },
    fullWidthXl: { type: Boolean },
    fullWidth2xl: { type: Boolean },
    gap: {},
    gapSm: {},
    gapMd: {},
    gapLg: {},
    gapXl: {},
    gap2xl: {},
    grow: { type: Boolean },
    growSm: { type: Boolean },
    growMd: { type: Boolean },
    growLg: { type: Boolean },
    growXl: { type: Boolean },
    grow2xl: { type: Boolean },
    justifyContent: {},
    justifyContentSm: {},
    justifyContentMd: {},
    justifyContentLg: {},
    justifyContentXl: {},
    justifyContent2xl: {},
    order: {},
    orderSm: {},
    orderMd: {},
    orderLg: {},
    orderXl: {},
    order2xl: {},
    rowGap: {},
    rowGapSm: {},
    rowGapMd: {},
    rowGapLg: {},
    rowGapXl: {},
    rowGap2xl: {},
    shrink: { type: Boolean },
    shrinkSm: { type: Boolean },
    shrinkMd: { type: Boolean },
    shrinkLg: { type: Boolean },
    shrinkXl: { type: Boolean },
    shrink2xl: { type: Boolean },
    spaceItems: {},
    spaceItemsSm: {},
    spaceItemsMd: {},
    spaceItemsLg: {},
    spaceItemsXl: {},
    spaceItems2xl: {},
    spacer: {},
    spacerSm: {},
    spacerMd: {},
    spacerLg: {},
    spacerXl: {},
    spacer2xl: {}
  },
  setup(c) {
    return (l, y) => (p(), t(r(l.component), {
      class: s([e(o).flex, e(n)(l.$props, [
        "align",
        "alignContent",
        "alignItems",
        "alignSelf",
        "columnGap",
        "flex",
        "fullWidth",
        "gap",
        "grow",
        "justifyContent",
        "rowGap",
        "shrink",
        "spaceItems",
        "spacer"
      ], e(o)), e(n)(l.$props, [
        "direction",
        "display",
        "flexWrap"
      ], e(o), { short: !0 })]),
      style: i({
        ...e(f)(l.$props, "order", d.name)
      })
    }, {
      default: m(() => [
        g(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "style"]));
  }
});
export {
  X as default
};
